import { formatDateTime, parseDateTime } from 'utils/dates/date.utils';
import { displayMarineValue, hasMarineValue } from '../../../utils/marineForecast.utils';

const getObservationTimestamp = (entry) =>
  parseDateTime(entry?.utcTime)?.getTime() ?? Number.NEGATIVE_INFINITY;

/**
 * Groups buoy condition entries by their location and sorts observations by the most recent timestamp.
 */
export const getBuoyConditionLocations = (buoyConditions = []) => {
  const locationsMap = new Map();

  buoyConditions.filter(Boolean).forEach((entry, index) => {
    const buoyId = hasMarineValue(entry?.buoy_id) ? String(entry.buoy_id) : null;
    const buoyName = displayMarineValue(entry?.buoy_name, null);
    const locationKey = buoyId ? `buoy-${buoyId}` : `location-${buoyName ?? index}`;
    const location = locationsMap.get(locationKey) ?? {
      locationKey,
      locationName: buoyName ?? (buoyId ? `Buoy ${buoyId}` : 'Unnamed Buoy'),
      observations: [],
    };

    location.observations.push(entry);
    locationsMap.set(locationKey, location);
  });

  // Returns the locations with their observations sorted by the most recent timestamp (ASC order)
  return Array.from(locationsMap.values()).map((location) => {
    const observations = [...location.observations].sort(
      (firstEntry, secondEntry) =>
        getObservationTimestamp(secondEntry) - getObservationTimestamp(firstEntry),
    );

    return {
      ...location,
      observations,
      latestObservation: observations[0] ?? null,
    };
  });
};

export const getBuoyObservationCardKey = (entry, index) => {
  const keyParts = [entry?.buoy_id, entry?.utcTime].filter(hasMarineValue);
  return keyParts.length ? keyParts.join('-') : `observation-${index}`;
};

export const getBuoyObservationCardTitle = (entry) => {
  const observationTime = formatDateTime(entry?.utcTime, 'short', null);

  return observationTime ? `Observed ${observationTime}` : 'Current Conditions';
};

export const getBuoyLocationSubtitle = (location) =>
  formatDateTime(location?.latestObservation?.utcTime, 'short', null);
